// @flow

import React from "react";
import { connect } from "react-redux";

import { SelectCircle } from "./styles";
import Icon from "src/icons";
import { selectMessage, deselectMessage } from "src/actions/chatmenu";

import type { AppState } from "src/types";
import { getSelectedAction } from "src/reducers";

type Props = {
  selectedAction: string,
  isMessageSelected: boolean,
  disabled?: boolean,
};

const SelectIndicator = ({
  selectedAction,
  isMessageSelected = false,
  disabled = false,
}: Props) => {
  return (
    <>
      {selectedAction && selectedAction !== "MOBILE" ? (
        <SelectCircle disabled={disabled}>
          <Icon
            type={isMessageSelected ? "activeCheckbox" : "defaultCheckbox"}
          />
        </SelectCircle>
      ) : null}
    </>
  );
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  selectedAction: getSelectedAction(app),
});

export default connect(mapStateToProps, {
  select: selectMessage,
  deselect: deselectMessage,
})(SelectIndicator);
